(function () {
  var STORAGE_KEY = 'hero_exp_variant';
  var COOKIE_NAME = 'hero_exp_variant';
  var COOKIE_DAYS = 30;
  var SCROLL_THRESHOLDS = [25, 50, 75, 100];

  function isHomepage() {
    var template = (window.Theme && Theme.template && Theme.template.name) || '';
    var bodyTemplate = document.body && document.body.getAttribute('data-template');
    var main = document.getElementById('MainContent');
    var mainTemplate = main && main.getAttribute('data-template');
    return (
      template === 'index' ||
      bodyTemplate === 'index' ||
      mainTemplate === 'index' ||
      Boolean(document.querySelector('.hero-exp-banner, .shopify-section.hero-exp--c'))
    );
  }

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function writeCookie(name, value) {
    var expires = new Date(Date.now() + COOKIE_DAYS * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function isShown(element) {
    if (!element) return false;
    return window.getComputedStyle(element).display !== 'none';
  }

  function getActiveVariant() {
    var fromAttr = document.documentElement.getAttribute('data-hero-exp');
    if (fromAttr === 'a' || fromAttr === 'b' || fromAttr === 'c') return fromAttr;

    var variantC = document.querySelector('.shopify-section.hero-exp--c');
    if (isShown(variantC)) return 'c';

    var variantB = document.querySelector('.hero-exp--b');
    if (isShown(variantB)) return 'b';

    var variantA = document.querySelector('.hero-exp--a');
    if (isShown(variantA)) return 'a';

    return '';
  }

  function persistVariant(variant) {
    try {
      sessionStorage.setItem(STORAGE_KEY, variant);
    } catch (error) {
      // Ignore storage failures.
    }
    writeCookie(COOKIE_NAME, variant);
    syncHiddenVariants(variant);
  }

  function syncHiddenVariants(variant) {
    document.querySelectorAll('.hero-exp-banner').forEach(function (el) {
      el.setAttribute('aria-hidden', variant === 'c' ? 'true' : 'false');
    });
    var variantC = document.querySelector('.shopify-section.hero-exp--c');
    if (variantC) {
      variantC.setAttribute('aria-hidden', variant === 'c' ? 'false' : 'true');
    }
    var variantA = document.querySelector('.hero-exp--a');
    var variantB = document.querySelector('.hero-exp--b');
    if (variantA) variantA.setAttribute('aria-hidden', variant === 'a' ? 'false' : 'true');
    if (variantB) variantB.setAttribute('aria-hidden', variant === 'b' ? 'false' : 'true');
  }

  function getAttributedVariant() {
    var live = getActiveVariant();
    if (live) return live;
    try {
      return sessionStorage.getItem(STORAGE_KEY) || readCookie(COOKIE_NAME) || 'a';
    } catch (error) {
      return readCookie(COOKIE_NAME) || 'a';
    }
  }

  function track(eventName, payload) {
    var data = Object.assign({ variant_id: getAttributedVariant() }, payload || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, data));

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(eventName, data);
    }
  }

  function markCtas() {
    document.querySelectorAll('.hero-exp-banner .primary-btn').forEach(function (cta) {
      cta.setAttribute('data-hero-exp-cta', '');
    });
  }

  function bindCtaClicks() {
    document.addEventListener(
      'click',
      function (event) {
        var cta = event.target.closest('[data-hero-exp-cta]');
        if (!cta) return;
        track('hero_exp_cta_click', {
          cta_text: (cta.textContent || '').trim(),
          cta_href: cta.getAttribute('href') || '',
        });
      },
      true
    );
  }

  function bindTrustClicks() {
    document.addEventListener(
      'click',
      function (event) {
        var trust = event.target.closest('.hero-exp-trust');
        if (!trust) return;
        track('hero_exp_trust_click', {
          trust_text: (event.target.textContent || '').trim().slice(0, 80),
        });
      },
      true
    );
  }

  function bindScrollDepth() {
    var seen = {};
    function onScroll() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var percent = Math.round((window.scrollY / scrollable) * 100);
      SCROLL_THRESHOLDS.forEach(function (threshold) {
        if (percent >= threshold && !seen[threshold]) {
          seen[threshold] = true;
          track('hero_exp_scroll_depth', { scroll_depth: threshold });
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function bindAddToCart() {
    document.addEventListener('cart:update', function (event) {
      var detail = event.detail || {};
      var data = detail.data || {};
      if (data.didError) return;
      track('hero_exp_add_to_cart', {
        product_id: data.productId || '',
        variant_id_product: data.variantId || '',
        item_count: data.itemCount || 0,
      });
    });
  }

  function initHomepage() {
    markCtas();
    bindCtaClicks();
    bindTrustClicks();
    bindScrollDepth();

    var start = Date.now();
    var maxWait = 1600;

    function resolveAndTrackPageview() {
      var variant = getActiveVariant() || 'a';
      persistVariant(variant);
      document.documentElement.setAttribute('data-hero-exp-resolved', variant);
      track('hero_exp_pageview', {
        page_path: window.location.pathname,
      });
    }

    function waitForIntelligems() {
      var variant = getActiveVariant();
      var queryVariant = new URLSearchParams(window.location.search).get('hero_exp');
      if (queryVariant === 'a' || queryVariant === 'b' || queryVariant === 'c' || Date.now() - start >= maxWait) {
        resolveAndTrackPageview();
        return;
      }
      if (variant === 'b' || variant === 'c') {
        resolveAndTrackPageview();
        return;
      }
      setTimeout(waitForIntelligems, 200);
    }

    waitForIntelligems();
  }

  function initAttribution() {
    bindAddToCart();
  }

  function boot() {
    initAttribution();
    if (isHomepage()) {
      initHomepage();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
